class BMI {
    bmi = 0;
    adjustedWeight = 0;
    idealBodyWeight = 0;

    constructor($el) {
        this.$el = $el;
        this.$height = $('[name="height"]');
        this.$weight = $('[name="weight"]');
        this.$output = this.$el.find('[data-value="bmi"]');
        this.gender = this.$el.find('[data-value="gender"]').val();
        this.age = this.$el.find('[data-value="age"]').val();

        this.init();
    }

    init = () => {
        this.$height.on('input', this.inputChangeHandler);
        this.$weight.on('input', this.inputChangeHandler);
        this.inputChangeHandler();
    }

    inputChangeHandler = () => {
        const height = this.$height.val();
        const weight = this.$weight.val();

        this.weight = weight;
        this.height = height;

        this.calculateIdealBodyWeight();

        if (height.length >= 3 && weight.length >= 2) {
            this.bmi = Number.parseFloat(weight / ((height / 100) * (height / 100))).toFixed(2);
        } else {
            this.bmi = 0;
        }

        this.calculateAdjustedWeight();

        this.$output.val(this.bmi);
        this.$output.trigger('input');
    }

    calculateIdealBodyWeight = () => {
        // männlich
        if (this.gender == '1') {
            this.idealBodyWeight = this.height > 152.4 ? 50 + 2.3 * (((this.height) - 152.4) / 2.54) : this.weight;
        }
        // weiblich
        else if (this.gender == '2') {
            this.idealBodyWeight = this.height > 152.4 ? 45.5 + 2.3 * (((this.height) - 152.4) / 2.54) : this.weight;
        }
    }

    calculateAdjustedWeight = () => {
        if (this.bmi < 16) {
            this.adjustedWeight = this.idealBodyWeight + 0.4 * (this.weight - this.idealBodyWeight);
        } else if (this.bmi > 28) {
            this.adjustedWeight = this.idealBodyWeight * 1.3;
        } else {
            this.adjustedWeight = this.weight;
        }
    }
}

export default BMI;
